// document.addEventListener('DOMContentLoaded', () => {

//   const deliveryMethod = document.querySelector(
//     '[name="properties[お受け取り方法]"]'
//   );

//   const localDeliveryFields = document.querySelector(
//     '.local-delivery-fields'
//   );

//   if (!deliveryMethod || !localDeliveryFields) return;

//   function toggleLocalDeliveryFields() {
//     const value = deliveryMethod.value;

//     if (
//       value === 'pickup' ||
//       value === 'local_delivery' ||
//       value === 'ご来店受取' ||
//       value === '自社配達' ||
//       value === 'Store Pickup' ||
//       value === 'Local Delivery'
//     ) {
//       localDeliveryFields.style.display = 'block';
//     } else {
//       localDeliveryFields.style.display = 'none';
//     }
//   }

//   deliveryMethod.addEventListener('change', toggleLocalDeliveryFields);

//   toggleLocalDeliveryFields();

// });

document.addEventListener('DOMContentLoaded', () => {
  const deliveryMethod = document.querySelector(
    '[data-delivery-method-select]'
  );

  const localDeliveryFields = document.querySelector(
    '.local-delivery-fields'
  );

  const dateInput = document.querySelector(
    '[data-fg-property="delivery_date"]'
  );

  const timeSelect = document.querySelector(
    '[data-fg-property="delivery_time"]'
  );

  if (!deliveryMethod || !localDeliveryFields) return;

  function toggleLocalDeliveryFields() {
    const value = deliveryMethod.value;

    const isLocal =
      value === 'pickup' ||
      value === 'local_delivery' ||
      value === 'ご来店受取' ||
      value === '吉祥寺周辺エリア配達' ||
      value === 'Store Pickup' ||
      value === 'Local Delivery';

    localDeliveryFields.style.display = isLocal ? 'block' : 'none';

    if (dateInput) {
      dateInput.disabled = !isLocal;
    }

    if (timeSelect) {
      timeSelect.disabled = !isLocal;
    }
  }

  deliveryMethod.addEventListener('change', toggleLocalDeliveryFields);

  toggleLocalDeliveryFields();
});